import { styled } from '@mui/system'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

export const ConfirmDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    padding: '1.2rem',
  },
}))

export const ConfirmDialogTitle = styled(DialogTitle)(() => ({
  marginBottom: '1.2rem',
  padding: '0',
}))

export const ConfirmDialogContent = styled(DialogContent)(() => ({
  marginBottom: '1.8rem',
  padding: '0',
}))

export const ConfirmDialogActions = styled(DialogActions)(() => ({ padding: '0' }))
